// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__kMNW-","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__297Hg"};